export default __webpack_public_path__ + "static/media/(8).b3cbfda4.jpg";